import React, {useEffect, useRef, useState} from 'react';
import MainContainer from "../MainContainer";
import css from './LogBook.module.scss'
import '../../../styles/index.scss'
import filterDisabled from '../../../images/filter_disabled.svg'
import shareDisabled from '../../../images/share_disabled.svg'
import image from '../../../images/standing-empty-log.svg'
import darkImage from '../../../images/white_man.svg'
import plus from '../../../images/plus.svg'
import close from '../../../images/close.svg'
import filter from '../../../images/filter.svg'
import table from '../../../images/table.svg'
import share from '../../../images/share.svg'
import arrows from '../../../images/arrows.svg'
import LogBookItem from "./LogBookItem";
import file from '../../../images/file.svg'
import addUser from '../../../images/add-user.svg'
import submenu from '../../../images/submenu.svg'
import item1 from '../../../images/send.svg'
import item2 from '../../../images/eye_menu.svg'
import item3 from '../../../images/edit.svg'
import item4 from '../../../images/trash.svg'
import darkItem1 from '../../../images/white_send.svg'
import darkItem2 from '../../../images/white_eye.svg'
import darkItem3 from '../../../images/white_edit.svg'
import darkItem4 from '../../../images/white_trash.svg'
import ReactTooltip from "react-tooltip";
import Filters from "./Filters";
import {
  ALL_PERIOD,
  ALL_TIME_BEFORE,
  ALL_TIME_FROM,
  CUSTOM,
  defaultColumns,
  filters,
  LAST_YEAR
} from "../../../redux/types";
import EditTable from "./EditTable";
import AddLogBook from "../../common/modals/AddLogBook/AddLogBook";
import {RemoveScrollBar} from "react-remove-scroll-bar";
import CreateModel from "../../common/modals/CreateModel";
import TripInfo from "../../common/modals/TripInfo/TripInfo";
import ShareTrip from "../../common/modals/ShareTrip/ShareTrip";
import SendLogBook from "../../common/modals/SendLogBook";
import withAuthRedirect from "../../common/hoc/withCheckAuth";
import {connect} from "react-redux";
import {deleteTrip, getCurrentCrewFile, getTrips} from "../../../redux/logbook/logbook-thunks";
import {NavLink} from "react-router-dom";
import {withRouter} from "react-router";
import {setCurrentCrewFile, setInviteTrip, setTrips} from "../../../redux/logbook/logbook-actions";
import {sendConfirmEmail} from "../../../redux/user/user-thunks";
import ConfirmEmail from "../../common/modals/ConfirmEmail";
import {fromDateToStringDate, getStringDate} from "../../../utils";
import {useTranslation} from "react-i18next";
import FileViewer from "../../common/modals/FileViewer";
import {getNotifications} from "../../../redux/notifications/notifications-thunks";
import {setIsEmailConfirmed} from "../../../redux/auth/auth-actions";

const LogBook = ({isDark, setTheme, user, trips, ...props}) => {
  const mainLogbookRef = useRef(null)
  const [isShowModal, setIsShowModal] = useState(false) // modal "Добавьте email"
  const [isSendedConfirmMail, setIsSendedConfirmMail] = useState(false) // tost "Подтвердите email"
  const [isFilter, setIsFilter] = useState(false) // is show filters block
  const [isEditTable, setIsEditTable] = useState(false) // is show edit table checkboxes
  const [isAddLog, setIsAddLog] = useState(false) // modal "Добавить информацию о походе"
  const [editLog, setEditLog] = useState(null) // modal "Редактировать информацию о походе"
  const [isEditSubmitModal, setIsEditSubmitModal] = useState(false) // modal "Подвердить изменение о походе"
  const [isDraftModal, setIsDraftModal] = useState(false) // modal "Сохранить в черновик"
  const [isCreateModal, setIsCreateModal] = useState(false) // modal "Создать модель яхты"
  const [currentDeleteItem, setCurrentDeleteItem] = useState(null) // pressed logbook item to delete
  const [currentShowItem, setCurrentShowItem] = useState(null) // pressed logbook item to show info
  const [currentShareTrip, setCurrentShareTrip] = useState(null) // pressed logbook item to share info
  const [isSendLogModal, setIsSendLogModal] = useState(false) // modal "Отправить логбук"
  const [selectedFilters, setSelectedFilters] = useState(defaultColumns) // selected columns to show in logbook
  const [isScrollable, setIsScrollable] = useState(false) // is scrollable logbook
  const [hoveredElement, setHoveredElement] = useState(null) // current hovered element
  const [isSortedDate, setIsSortedDate] = useState(false) // is sorted by date column
  //filters
  const [selectedDateFilter, setSelectedDateFilter] = useState(ALL_PERIOD)
  const [selectedRoles, setSelectedRoles] = useState([])
  const [selectedYachtTypes, setSelectedYachtTypes] = useState([])
  const [selectedCountries, setSelectedCountries] = useState([])
  const [selectedTidal, setSelectedTidal] = useState(undefined)
  const isSelectedFilter = selectedDateFilter !== ALL_PERIOD || selectedRoles.length !== 0 || selectedYachtTypes.length !== 0
    || selectedCountries.length !== 0 || selectedTidal !== undefined
  const [state, setState] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);
  const [fromDate, setFromDate] = useState(null)
  const [beforeDate, setBeforeDate] = useState(null)
  const columns = filters.slice(1, filters.length - 1)
  const {t} = useTranslation()
  const logBookWidth = selectedFilters.reduce((acum, value) => {
    if (value.width !== undefined) return +acum + value.width
    else return acum
  }, 0) // count width of logbook columns
  useEffect(() => {
    setIsScrollable(mainLogbookRef.current?.scrollWidth > mainLogbookRef.current?.clientWidth) // is scrollable main logbook
  }, [selectedFilters])
  const isShowDates = selectedFilters.find(s => s.name === 'Даты')
  let isEmpty = trips === null
  useEffect(() => {
    props.getTrips()
    props.getNotifications()
  }, [props.user])
  return (
    <MainContainer isDark={isDark} setTheme={() => setTheme(!isDark)}>
      {props.isEmailConfirmed && <div className={'tost'}>
        {t('successAccept')}
        <button onClick={() => props.setIsEmailConfirmed(false)} className={'tost__close'}>
          <img src={close} alt=""/>
        </button>
      </div>}
      {isDraftModal && <div style={{maxWidth: 440}} className={`modal small-modal ${isDark && 'modal__dark'}`}>
        <button onClick={() => setIsDraftModal(false)} className="modal__close small-modal__close">
          <img src={close} alt=""/>
        </button>
        <p className="modal__text">{t('savedInDraft')}</p>
        <button onClick={() => setIsDraftModal(false)} className="submit-button modal__submit">
          ok
        </button>
      </div>}
      {!isEmpty && <button onClick={() => {
        if (!!user.is_active) {
          setIsAddLog(true)
        } else {
          setIsShowModal(true)
        }
      }} className={`empty__plus addButton`}>
        <img src={plus} alt=""/>
      </button>}
      <div className={css.row}>
        <p style={{color: !isEmpty ? 'rgba(0, 0, 0, 0.85)' : 'rgba(0, 0, 0, 0.32)'}}
           className={`${css.info} ${isDark && css.info__dark}`}>
          <span className={css.info__label}>{t('yachtExp')}:</span>
          <span
            className={'ml-15'}>{props.experience?.miles ?? 0}</span> {t('nauticalMiles')}
          <span className={'ml-15'}>
            {props.experience?.days ?? 0}
          </span> {t('days')}
        </p>
        <div className={`${css.buttons} ${isDark && css.buttons__dark}`}>
          <button onClick={() => {
            setIsEditTable(false)
            setIsFilter(!isFilter)
          }} disabled={isEmpty}
                  className={`${css.filterButton} mr-24 ${(isFilter || isSelectedFilter) && css.filterButton__selected}`} data-tip
                  data-for={'filter'}>
            <img src={isEmpty ? filterDisabled : filter} alt=""/>
          </button>
          <ReactTooltip className={`${isDark && 'tooltip tooltip__dark'}`}
                        backgroundColor={isDark ? '#FFFFFF' : '#52616E'}
                        id={'filter'} place="top" effect="solid">
            {t('filterSet')}
          </ReactTooltip>
          {!isEmpty && <>
            <button onClick={() => {
              setIsFilter(false)
              setIsEditTable(!isEditTable)
            }}
                    className={`${css.filterButton} mr-24 ${isEditTable && css.filterButton__selected}`} data-tip
                    data-for={'edit'}>
              <img src={table} alt=""/>
            </button>
            <ReactTooltip className={`${isDark && 'tooltip tooltip__dark'}`}
                          backgroundColor={isDark ? '#FFFFFF' : '#52616E'}
                          id={'edit'} place="top" effect="solid">
              {t('editColumns')}
            </ReactTooltip>
          </>}
          <button onClick={() => setIsSendLogModal(true)} disabled={isEmpty}
                  className={`${css.sendLogbook} ${isEmpty && css.sendLogbook__disabled}`}>
            <img src={isEmpty ? shareDisabled : share} alt="" style={{marginRight: 12}}/>
            {t('sendLog')}
          </button>
        </div>
      </div>
      {isFilter &&
      <Filters isDark={isDark} selectedRoles={selectedRoles} selectedYachtTypes={selectedYachtTypes}
               selectedTidal={selectedTidal} selectedDateFilter={selectedDateFilter}
               state={state} beforeDate={beforeDate} fromDate={fromDate} setSelectedDateFilter={setSelectedDateFilter}
               setSelectedRoles={setSelectedRoles} setSelectedYachtTypes={setSelectedYachtTypes}
               setSelectedTidal={setSelectedTidal} setState={setState} setFromDate={setFromDate}
               setBeforeDate={setBeforeDate} selectedCountries={selectedCountries}
               setSelectedCountries={setSelectedCountries}
      />}
      {isEditTable &&
      <EditTable isDark={isDark} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters}/>}
      {!isEmpty ? <>
        <div className={`${css.logbook} ${isDark && css.logbook__dark}`}>
          <div className={`${css.logbook__column} ${isScrollable && 'shadow-right'}`}>
            {isShowDates && <>
              <div className={css.logbook__title}>
                <button onClick={() => {
                  props.setTrips([...trips.sort((a, b) => {
                    setIsSortedDate(!isSortedDate)
                    if (!isSortedDate) return new Date(b.start_date) - new Date(a.start_date)
                    else return new Date(a.start_date) - new Date(b.start_date)
                  })])
                }} className={css.logbook__item}>
                  {t('startDate')}
                  <div className={css.logbook__sort}>
                    <img src={arrows} alt=""/>
                  </div>
                </button>
                <button style={{width: '87px', padding: 0}} className={css.logbook__item}>
                  {t('days')}
                  <div className={css.logbook__sort}>
                    <img src={arrows} alt=""/>
                  </div>
                </button>
              </div>
              <div className={css.logbook__values}>
                {trips.map((trip, index) => <div
                  key={index} //${log.isDisabled && css.logbook__disabledValue} - disabled row
                  className={`${trip.is_draft && css.logbook__disabledValue} ${css.logbook__value} ${hoveredElement === index && (isDark ? 'bg-darkblue' : 'bg-blue')}`}
                  onMouseOver={() => setHoveredElement(index)}
                  onClick={() => setCurrentShowItem({...trip})}
                  onMouseLeave={() => setHoveredElement(null)}>
                  <span style={{width: '140px'}}>{fromDateToStringDate(trip.start_date)}</span>
                  <span>{(new Date(trip.finish_date) - new Date(trip.start_date)) / (24 * 3600 * 1000)}</span>
                </div>)}
              </div>
            </>}
          </div>
          <div className={css.logbook__main} ref={mainLogbookRef}>
            <div style={{
              width: `${logBookWidth}px`,
              minWidth: window?.innerWidth > 1250 ? isShowDates ? '1000px' : '1250px' : window?.innerWidth - (isShowDates ? 460 : 190)
            }}>
              <div className={css.logbook__title}>
                {columns.map((col, index) => <button key={index}
                                                     style={{width: filters[index + 1].width}}
                                                     className={`${css.logbook__item}
                                                     ${!selectedFilters.find(s => s.name === col.name) && 'hidden-block'}`}>
                  {t(col.label)}
                  <div className={css.logbook__sort}>
                    <img src={arrows} alt=""/>
                  </div>
                </button>)}
              </div>
              <div className={css.logbook__items}>
                {trips.map((trip, index) => <LogBookItem key={index} logItem={trip} selectedFilters={selectedFilters}
                                                         isHover={hoveredElement === index}
                                                         onClick={() => setCurrentShowItem({...trip})}
                                                         setHoveredElement={setHoveredElement} index={index}
                                                         isDark={isDark}/>)}
              </div>
            </div>
          </div>
          <div className={`${css.logbook__column} ${isScrollable && 'shadow-left'} w-160`}>
            <div className={css.logbook__title}>
              <div className={css.logbook__item}/>
            </div>
            <div className={css.logbook__values}>
              {trips.map((trip, index) => <div key={index}
                                               className={`${css.logbook__value} ${css.logbook__buttons} ${hoveredElement === index && (isDark ? 'bg-darkblue' : 'bg-blue')}`}
                                               onMouseOver={() => setHoveredElement(index)}
                                               onMouseLeave={() => setHoveredElement(null)}>
                {(trip.crew_list_file_link && selectedFilters.find(s => s.name === 'Крю-лист')) && <>
                  <button onClick={() => props.getCurrentCrewFile(trip.crew_list_file_link)} data-tip
                          data-for={trip.start_date + index} className={css.logbook__button}>
                    <img src={file} alt=""/>
                  </button>
                  <ReactTooltip className={`${isDark && 'tooltip tooltip__dark'}`}
                                backgroundColor={isDark ? '#FFFFFF' : '#52616E'}
                                id={trip.start_date + index} place="top" effect="solid">
                    {t('crewList')}
                  </ReactTooltip>
                </>}

                {!trip.is_draft &&
                <button onClick={() => setCurrentShareTrip({...trip})} className={css.logbook__button}>
                  <img src={addUser} alt=""/>
                </button>}
                <button className={`${css.logbook__button} submenuTrig`}>
                  <img src={submenu} alt=""/>
                </button>
                <div className={`submenu ${isDark && 'submenu__dark'}`}>
                  <button onClick={() => setCurrentShareTrip({...trip})} className={'submenuItem'}>
                    <img src={isDark ? darkItem1 : item1} alt="" className={'submenuIcon'}/>
                    {t('share')}
                  </button>
                  <button onClick={() => setCurrentShowItem({...trip})} className={'submenuItem'}>
                    <img src={isDark ? darkItem2 : item2} alt="" className={'submenuIcon'}/>
                    {t('preview')}
                  </button>
                  <button onClick={() => setEditLog({...trip})} className={'submenuItem'}>
                    <img src={isDark ? darkItem3 : item3} alt="" className={'submenuIcon'}/>
                    {t('edit')}
                  </button>
                  <button onClick={() => setCurrentDeleteItem({...trip})} className={'submenuItem'}>
                    <img src={isDark ? darkItem4 : item4} alt="" className={'submenuIcon'}/>
                    {t('delete')}
                  </button>
                </div>
              </div>)}
            </div>
          </div>
        </div>
        {props.isMoreTrips && <div className="showMore__wrapper">
          <button onClick={() => {
            let newDate = new Date()
            newDate.setFullYear(newDate.getFullYear() - 1)
            props.getTrips({
              offset: trips.length,
              roleIds: selectedRoles.map(r => r.id),
              yachtTypeIds: selectedYachtTypes.map(r => r.id),
              tidal: selectedTidal,
              countries: selectedCountries,
              dateBefore: selectedDateFilter === CUSTOM ? getStringDate(state[0].endDate)
                : selectedDateFilter === ALL_TIME_BEFORE ? getStringDate(beforeDate) : undefined,
              dateAfter: selectedDateFilter === CUSTOM ? getStringDate(state[0].startDate)
                : selectedDateFilter === ALL_TIME_FROM ? getStringDate(fromDate) :
                  selectedDateFilter === LAST_YEAR ? getStringDate(newDate) : undefined
            })
          }} className="showMore">{t('showMore')}</button>
        </div>}
      </> : <div className={`wrapper`}>
        <div className={`empty ${isDark && 'empty__dark'}`}>
          <img src={isDark ? darkImage : image} alt=""/>
          <div className={'empty__info'}>
            <p className={'empty__title'}>
              {t('hello')}
            </p>
            <p className={'empty__text'}>
              {t('yourLogEmpty')}
            </p>
            <p className={'empty__text'}>
              {t('pressPlusToAdd')}
            </p>
          </div>
          <button onClick={() => {
            if (!!user.is_active) {
              setIsAddLog(true)
            } else {
              setIsShowModal(true)
            }
          }} className={'empty__plus'}>
            <img src={plus} alt=""/>
          </button>
        </div>
      </div>}
      {(isAddLog || editLog || isEditSubmitModal || isDraftModal || isCreateModal || props.currentCrewFile
        || currentDeleteItem || currentShowItem || isShowModal || currentShareTrip || isSendLogModal || props.inviteTrip) && <>
        <div className="overlay"/>
        <RemoveScrollBar/>
      </>}
      {(isAddLog || props.inviteTrip) && <AddLogBook closeModal={() => {
        setIsAddLog(false)
        props.setInviteTrip(null)
      }}
                                                     onSaveInDraft={() => setIsDraftModal(true)}
                                                     openCreateModel={() => setIsCreateModal(true)}
                                                     isCreateModel={isCreateModal} logItem={props.inviteTrip}
                                                     isInvite={props.inviteTrip !== null}/>}
      {editLog && <AddLogBook closeModal={() => setEditLog(null)}
                              onSubmit={() => setIsEditSubmitModal(true)}
                              onSaveInDraft={() => setIsDraftModal(true)}
                              logItem={editLog}
                              openCreateModel={() => setIsCreateModal(true)}
                              isCreateModel={isCreateModal}/>}
      {isEditSubmitModal && <div style={{maxWidth: 481}} className={`modal small-modal ${isDark && 'modal__dark'}`}>
        <button onClick={() => setIsEditSubmitModal(false)} className="modal__close">
          <img src={close} alt=""/>
        </button>
        <h5 className="modal__title">Редактирование похода</h5>
        <p className="modal__text mb-24">Владелец записи похода Вася Иванов. И предложенные вами правки будут
          внесены, <span className={'font800'}>после
            того, как Вася Иванов их подтвердит в своем логбуке</span>.</p>
        <p className="modal__text mb-24">Если ваши данные о походе существенно отличаются от данных Васи, вы можете
          создать
          копию похода через функцию “<span className={'font800'}>CLONE</span>” и редактировать уже ее самостоятельно.
        </p>
        <div className="modal__actions">
          <button onClick={() => setIsEditSubmitModal(false)} className="submit-button">
            ok
          </button>
          <button onClick={() => setIsEditSubmitModal(false)} className={`commonBtn ${isDark && 'commonBtn__dark'}`}>
            <span className={'commonBtn__label'}>CLONE</span>
          </button>
        </div>
      </div>}
      {isCreateModal && <CreateModel closeModal={() => {
        setIsCreateModal(false)
        setIsAddLog(true)
      }
      }/>}
      {currentDeleteItem && <div style={{maxWidth: 481}} className={`modal small-modal ${isDark && 'modal__dark'}`}>
        <h5 className="modal__title">{t('deleteTrip')}</h5>
        <button onClick={() => setCurrentDeleteItem(false)} className="modal__close small-modal__close">
          <img src={close} alt=""/>
        </button>
        <p className="modal__text">{t('isDeleteTrip')}</p>
        <div className="modal__actions mt-40">
          <button onClick={() => {
            props.deleteTrip(currentDeleteItem.id)
            setCurrentDeleteItem(null)
          }} className="delete-button mr-24">
            {t('delete')}
          </button>
          <button onClick={() => setCurrentDeleteItem(null)} className={`commonBtn ${isDark && 'commonBtn__dark'}`}>
            <span className="commonBtn__label">{t('cancel')}</span>
          </button>
        </div>
      </div>}
      {props.currentCrewFile && <FileViewer closeModal={() => props.setCurrentCrewFile(null)}
                                            isDark={isDark}/>}
      {currentShowItem && <TripInfo closeModal={() => setCurrentShowItem(null)} logItem={currentShowItem}/>}
      {currentShareTrip && <ShareTrip tripId={currentShareTrip.id} trip={currentShareTrip}
                                      closeModal={() => setCurrentShareTrip(null)}/>}
      {isSendLogModal && <SendLogBook fields={selectedFilters} isDark={isDark} closeModal={() => setIsSendLogModal(false)}/>}
      {(!user?.is_active && !isSendedConfirmMail && !isShowModal) && <button className={'tost'}>
        {t('confirmMailTost')}
        <button onClick={() => setIsShowModal(true)} className={'tost__button'}>
          {t('sendAgainShort')}
        </button>
      </button>}
      {(isShowModal) && <ConfirmEmail isDark={isDark} closeModal={() => setIsShowModal(false)}
                                      onSubmit={() => {
                                        setIsSendedConfirmMail(true)
                                        props.sendConfirmEmail()
                                        setIsShowModal(false)
                                      }}/>}
    </MainContainer>
  );
};

const mapStateToProps = (state) => ({
  user: state.userReducer.user,
  trips: state.logbookReducer.trips,
  inviteTrip: state.logbookReducer.inviteTrip,
  currentCrewFile: state.logbookReducer.currentCrewFile,
  isEmailConfirmed: state.authReducer.isEmailConfirmed,
  experience: state.logbookReducer.experience,
  isMoreTrips: state.logbookReducer.isMoreTrips
})

export default connect(mapStateToProps, {
  getTrips,
  deleteTrip,
  setInviteTrip,
  sendConfirmEmail,
  setTrips,
  getCurrentCrewFile,
  setCurrentCrewFile,
  getNotifications,
  setIsEmailConfirmed
})(withRouter(React.memo(withAuthRedirect(LogBook))));

